import './index.scss'

import { useLocation, useNavigate } from 'react-router-dom'

// Icons
import plusPlain from 'url:@assets/icons/plus.plain.svg'
import infoPlain from 'url:@assets/icons/info.plain.svg'

export interface PageTab {
  label: string;
  path: string;
}

export type PageTabButtonIcon = 'add' | 'info';

export interface PageTabButton {
  label: string;
  icon: PageTabButtonIcon;
  onClick: () => void;
}

export default function PageTabs(props: {
  title: string,
  tabs: PageTab[],
  buttons?: PageTabButton[]
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedPath = selectedTabPath(props.tabs, location.pathname);

  return <div className='page-tabs'>
    <h2 className='header'>{props.title}</h2>

    {props.tabs.map((tab) => {
      return <button
        key={tab.path}
        type='button'
        className={tab.path === selectedPath ? 'page-tab selected' : 'page-tab'}
        onClick={() => navigate(tab.path)}>
        {tab.label}
      </button>
    })}

    {props.buttons && <>
      <div className='spacer' />
      <div className='page-tab-buttons'>
        {props.buttons.map((button) => {
          let icon;
          switch (button.icon) {
            case 'add':
              icon = plusPlain;
              break;
            case 'info':
              icon = infoPlain;
              break;
          }

          return <button
            key={button.label}
            type='button'
            className='page-tab-button'
            onClick={button.onClick}>
            <img src={icon} alt={button.label} aria-hidden='true' />
          </button>
        })}
      </div>
    </>}
  </div>
}

// A tab owns its path and everything nested under it, so the most specific
// match wins: /launchpad/tags belongs to Tags, /launchpad/{id} to Views.
function selectedTabPath(tabs: PageTab[], pathname: string): string | null {
  const matches = tabs.filter((tab) => {
    return pathname === tab.path || pathname.startsWith(`${tab.path}/`);
  });

  if (matches.length === 0) {
    return null;
  }

  return matches.reduce((longest, tab) => tab.path.length > longest.path.length ? tab : longest).path;
}
